var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconStarFour = function SvgIconStarFour(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M11 1.515a1.75 1.75 0 0 1 2.64.828l.002.006 2.136 5.873 5.873 2.135.006.002a1.75 1.75 0 0 1 0 3.282l-.006.002-5.873 2.135-2.136 5.873-.002.006a1.75 1.75 0 0 1-3.281 0l-.002-.006-2.136-5.873-5.873-2.135-.006-.002a1.75 1.75 0 0 1 0-3.282l.006-.002 5.873-2.135 2.136-5.873.002-.006A1.75 1.75 0 0 1 11 1.515m1 2.168 1.938 5.33.001.005a1.76 1.76 0 0 0 1.043 1.042l.004.002L20.316 12l-5.33 1.938-.004.002a1.76 1.76 0 0 0-1.043 1.042l-.001.004L12 20.316l-1.939-5.33-.001-.004a1.76 1.76 0 0 0-1.043-1.042l-.004-.002L3.683 12l5.33-1.938.004-.002a1.76 1.76 0 0 0 1.043-1.042l.001-.004z",
    clipRule: "evenodd"
  })));
};
export default SvgIconStarFour;